import WPMessageBanner from "./WPMessageBanner";
export default WPMessageBanner;
